module.exports = __webpack_public_path__ + "static/farshad-6046c951e53607e65d8aa60cb8760969.jpg";